import { LpButton } from '~/design-system';
const taskPrimaryColumns = [
    {
        column: getSortableColumn('brand', 'Brand', { width: 96, minWidth: 80, align: 'center' }),
        cell: { kind: 'brand' },
    },
    {
        column: getSortableColumn('idStatus', 'Status', { width: 132, minWidth: 112, align: 'center' }),
        cell: { kind: 'status' },
    },
    {
        column: getSortableColumn('idOperation', 'Operation', { width: 176, minWidth: 140, align: 'end' }),
        cell: { kind: 'text', className: 'align-right task_operation_name', binding: 'operation.name' },
    },
    {
        column: getSortableColumn('group', 'Pipeline', { width: 172, minWidth: 132 }),
        headerIf: 'hasPipelineFilter',
        cellIf: '$parent.hasPipelineFilter',
        cell: {
            kind: 'text',
            className: 'task_pipeline',
            binding: "(taskExecuter.group ? taskExecuter.group.name : 'Other') + ' (' + taskExecuter.taskExecuter + ')'",
        },
    },
    {
        column: getSortableColumn('dateOperation', 'Operation Date', { width: 164, minWidth: 132 }),
        cell: { kind: 'text', className: 'align-left task_date_operation', binding: 'dateOperation' },
    },
    {
        column: getSortableColumn('dateScheduled', 'Scheduled Date', { width: 164, minWidth: 132 }),
        cell: { kind: 'text', className: 'align-left task_date_scheduled', binding: 'dateScheduled' },
    },
    {
        column: getSortableColumn('dateExecuted', 'Execution Date', { width: 164, minWidth: 132 }),
        cell: { kind: 'text', className: 'align-left task_data_executed', binding: 'dateExecuted' },
    },
    {
        column: getSortableColumn('executionTime', 'Time to Execute', { width: 152, minWidth: 124 }),
        cell: { kind: 'text', className: 'align-left task_date_creation', binding: 'executionTime' },
    },
    {
        column: getSortableColumn('extraInfo', 'Extra Info', { width: 180, minWidth: 132 }),
        cell: { kind: 'text', className: 'task_extra_info', binding: 'extraInfo' },
    },
    {
        column: getSortableColumn('nbErrors', 'Errors', { width: 96, minWidth: 80, align: 'center' }),
        cell: { kind: 'text', className: 'task_nb_errors', binding: 'nbErrors' },
    },
    {
        column: getSortableColumn('userInfo', 'User Info/Type', { width: 132, minWidth: 112 }),
        cell: {
            kind: 'text',
            className: 'task_user_info',
            binding: "[String(userInfo || '').substring(0,4), String(type || '').substring(0,4)].join('-')",
        },
    },
];
const taskSecondaryBaseColumns = [
    {
        column: getSortableColumn('pid', 'pid', { width: 96, minWidth: 80 }),
        cell: { kind: 'text', className: 'task_pid', binding: 'pid' },
    },
    {
        column: getSortableColumn('id', 'Id', { width: 88, minWidth: 72 }),
        cell: { kind: 'text', className: 'task_id', binding: 'id' },
    },
    {
        column: getSortableColumn('dateCreation', 'Creation Date', { width: 164, minWidth: 132 }),
        cell: { kind: 'text', className: 'task_date_creation', binding: 'dateCreation' },
    },
    {
        column: getSortableColumn('dateUpdated', 'Updated Date', { width: 164, minWidth: 132 }),
        cell: { kind: 'text', className: 'task_date_updated', binding: 'dateUpdated && dateUpdated.date' },
    },
    {
        column: getSortableColumn('idTaskExecuter', 'Task Executor', { width: 164, minWidth: 132 }),
        cell: { kind: 'text', className: 'task_taskExecuter_name', binding: 'taskExecuter && taskExecuter.name' },
    },
    {
        column: getSortableColumn('userInfo', 'User Info', { width: 132, minWidth: 112 }),
        cell: { kind: 'text', className: 'task_user_info', binding: 'userInfo' },
    },
    {
        column: getSortableColumn('type', 'Type', { width: 112, minWidth: 96 }),
        cell: { kind: 'text', className: 'task_type', binding: 'type' },
    },
];
const taskSecondaryColumns = taskSecondaryBaseColumns.map((taskColumn) => {
    return {
        ...taskColumn,
        column: {
            ...taskColumn.column,
            headerAttributes: {
                ...taskColumn.column.headerAttributes,
                'data-bind': 'visible: listMoreInfo',
            },
        },
        cellAttributes: { 'data-bind': 'visible: $parent.listMoreInfo' },
    };
});
export function renderTasksTable() {
    return /* html */ `
        <div class="table-scroll">
            <div class="table-scroll__wrapper">
                <table class="tbl list-results list-page-table list-sections body-min-height" id="list-results-table" style="white-space: nowrap">
                    <thead>
                        <input data-bind="value: orderBy" type="hidden">
                        <input data-bind="value: orderByDirection" type="hidden">
                        <tr>
                            ${getTaskSelectAllHeaderHtml()}
                            ${getTaskRescheduleHeaderHtml()}
                            ${renderTaskColumnHeaders(taskPrimaryColumns)}
                            ${renderTaskColumnHeaders(taskSecondaryColumns)}
                            ${getTaskDeleteHeaderHtml()}
                        </tr>
                    </thead>
                    <tbody data-bind="foreach: tasks" id="list-results-body">
                        <tr data-bind="css: { 'is-checked': checked, 'is-reschedule': ($parent.taskToReschedule() != null && $parent.taskToReschedule()['id'] == id) }">
                            ${getTaskSelectionCellHtml()}
                            ${getTaskRescheduleCellHtml()}
                            ${renderTaskColumnCells(taskPrimaryColumns)}
                            ${renderTaskColumnCells(taskSecondaryColumns)}
                            ${getTaskDeleteCellHtml()}
                        </tr>
                    </tbody>
                    <tfoot>
                    </tfoot>
                </table>
            </div>
        </div>
    `;
}
function renderTaskColumnHeaders(columns) {
    return columns.map((taskColumn) => {
        const header = getTaskSortableHeaderHtml(taskColumn.column.key, String(taskColumn.column.label), getAttributesHtml(taskColumn.column.headerAttributes));
        return wrapKoIf(header, taskColumn.headerIf);
    }).join('');
}
function getTaskSelectAllHeaderHtml() {
    return /* html */ `
        <!-- ko if: permissions()['tasklist_manage'] && permissions()['tasklist_manage'].update == true -->
            <th>
                <div style="display: flex;justify-content: center;">
                    <input type="checkbox" id="selectAll" value="checked" data-bind="checked: selectAllChecked, event: {click: setAllChecked}" >
                    <label for="selectAll" class="form-label icon i-check"></label>
                </div>
            </th>
        <!-- /ko -->
    `;
}
function getTaskRescheduleHeaderHtml() {
    return /* html */ `
        <!-- ko if: permissions()['tasklist_reschedule_task'] && permissions()['tasklist_reschedule_task'].write == true -->
            <th class="tbl-h">
                <div class="tbl-h-inner">
                    <span class="tbl-h-content">Reschedule</span>
                </div>
            </th>
        <!-- /ko -->
    `;
}
function getTaskDeleteHeaderHtml() {
    return /* html */ `
        <!-- ko if: permissions()['tasklist_manage'] && permissions()['tasklist_manage'].update == true -->
            <th class="tbl-h">
                <div class="tbl-h-inner">
                    <span class="tbl-h-content">Delete</span>
                </div>
            </th>
        <!-- /ko -->
    `;
}
function renderTaskColumnCells(columns) {
    return columns.map((taskColumn) => {
        const cell = renderTaskCell(taskColumn.cell, taskColumn.cellAttributes);
        return wrapKoIf(cell, taskColumn.cellIf);
    }).join('');
}
function renderTaskCell(cell, attributes) {
    if (cell.kind === 'brand') {
        return getTaskBrandCellHtml();
    }
    if (cell.kind === 'status') {
        return getTaskStatusCellHtml();
    }
    if (cell.kind === 'text') {
        return getTaskTextCellHtml(cell.className, cell.binding, getAttributesHtml(attributes));
    }
    return '';
}
function getTaskSelectionCellHtml() {
    return /* html */ `
        <!-- ko if: $parent.permissions()['tasklist_manage'] && $parent.permissions()['tasklist_manage'].update == true -->
            <td>
                <div style="margin-top:-1.25rem">
                    <input type="checkbox" value="checked" data-bind="checked: checked, value: id, attr:{id: 'task_' + id}, click: $parent.onClickChecked"/>
                    <label data-bind="text: name, attr:{for: 'task_' + id}" class="form-label icon i-check"></label>
                </div>
            </td>
        <!-- /ko -->
    `;
}
function getTaskRescheduleCellHtml() {
    return /* html */ `
        <!-- ko if: $parent.permissions()['tasklist_reschedule_task'] && $parent.permissions()['tasklist_reschedule_task'].write == true -->
            <td class="align-center">
                <!-- ko if: (status.id == null || status.id == 3) -->
                    ${LpButton({
        ariaLabel: 'Reschedule',
        prefixIcon: 'calendar-plus',
        size: 'sm',
        shape: 'square',
        variant: 'ghost',
        attributes: {
            'data-bind': 'click: $parent.onClickReschedule',
        },
    })}
                <!-- /ko -->
            </td>
        <!-- /ko -->
    `;
}
function getTaskDeleteCellHtml() {
    return /* html */ `
        <!-- ko if: $parent.permissions()['tasklist_manage'] && $parent.permissions()['tasklist_manage'].update == true -->
            <td class="align-right">
                ${LpButton({
        ariaLabel: 'Delete',
        prefixIcon: 'trash',
        size: 'sm',
        shape: 'square',
        variant: 'ghost',
        attributes: {
            'data-bind': 'click: $parent.onClickDelete',
        },
    })}
            </td>
        <!-- /ko -->
    `;
}
function wrapKoIf(content, binding) {
    if (!binding) {
        return content;
    }
    return /* html */ `
        <!-- ko if: ${binding} -->
            ${content}
        <!-- /ko -->
    `;
}
function getTaskBrandCellHtml() {
    return /* html */ `
        <td class="align-center task_brand">
                <img
                    class="brand-logo"
                    alt=""
                    data-bind="attr: { src: $parent.getBrandLogoSrc(brand), alt: brand, title: brand }"
                />
        </td>
    `;
}
function getTaskStatusCellHtml() {
    return /* html */ `
        <td class="align-center task_status_name">
                <span
                    class="task-status"
                    data-bind="text: status.name, css: 'task-status--' + String(status.name || 'pending').replace(/[^a-z0-9]+/gi, '-').toLowerCase()"
                ></span>
        </td>
    `;
}
function getTaskTextCellHtml(className, binding, attributes = '') {
    const attributesHtml = attributes ? ` ${attributes}` : '';
    return `<td class="${className}"${attributesHtml}><span data-bind="text: ${binding}"></span></td>`;
}
function getSortableColumn(key, label, options = {}) {
    return {
        key,
        label,
        sortable: true,
        resizable: true,
        sortAttributes: {
            'data-bind': `click: onClickReorder.bind($data, '${key}'), css: { 'is-desc': orderByAndDirection()=='${key}_DESC', 'is-asc': orderByAndDirection()=='${key}_ASC' }`,
        },
        ...options,
    };
}
function getTaskSortableHeaderHtml(column, label, attributes = '') {
    const attributesHtml = attributes ? ` ${attributes}` : '';
    return /* html */ `
        <th class="tbl-h"${attributesHtml}>
            <div class="tbl-h-inner">
                <span
                    data-bind="event: { click: onClickReorder.bind($data, '${column}') }, css: { 'list-sort-desc': orderByAndDirection()=='${column}_DESC', 'list-sort-asc': orderByAndDirection()=='${column}_ASC' }"
                    class="tbl-h-content icon list-sort-none"
                >${label}</span>
            </div>
        </th>
    `;
}
function getAttributesHtml(attributes) {
    if (!attributes) {
        return '';
    }
    return Object.entries(attributes)
        .filter(([, value]) => value !== undefined && value !== null && value !== false)
        .map(([key, value]) => value === true ? key : `${key}="${String(value)}"`)
        .join(' ');
}
